import { ISupportUser } from '@/features/dashboard-users/store/support-user.model';

interface IExpirationStatus {
  isExpired: boolean;
  isNearExpiration: boolean;
  isPermanent: boolean;
  accessExpirationDate: Date | undefined;
}

export function useExpirationStatus(dashboardUser?: ISupportUser): IExpirationStatus {
  if (!dashboardUser?.accessExpirationDate) {
    return {
      isExpired: false,
      isNearExpiration: false,
      isPermanent: true,
      accessExpirationDate: null,
    };
  }

  const accessExpirationDate = new Date(dashboardUser?.accessExpirationDate);

  const last = accessExpirationDate.getTime() - new Date().getTime();
  const isExpired = last <= 0;
  const isNearExpiration = last <= 2592000000;

  return {
    isExpired,
    isNearExpiration,
    isPermanent: false,
    accessExpirationDate,
  };
}
